import PropTypes from 'prop-types';

const ProductsView = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M18.571 8.57A1.43 1.43 0 0 0 20 7.143V6.14c0-.526-.288-1.008-.752-1.258L10.338.085a.71.71 0 0 0-.676 0L.752 4.882C.29 5.132 0 5.614 0 6.14v1.002c0 .788.64 1.429 1.429 1.429h.714v7.143h-.714A1.43 1.43 0 0 0 0 17.142v1.429c0 .788.64 1.428 1.429 1.428H18.57A1.43 1.43 0 0 0 20 18.572v-1.429a1.43 1.43 0 0 0-1.429-1.428h-.714V8.57zM1.43 6.14 10 1.525l8.571 4.615v1.002H1.43zm9.285 9.574V8.57h2.143v7.143zm-3.571 0V8.57h2.143v7.143zM3.57 8.57h2.143v7.143H3.571zm15.001 10H1.43v-1.429H18.57zm-2.143-2.857h-2.143V8.57h2.143z"
            fill={color}
        />
    </svg>
);

export default ProductsView;

ProductsView.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
